export default __webpack_public_path__ + "static/media/bg6.c2d52974.jpeg";